export default __webpack_public_path__ + "static/app-store-140776dd9bd3a11daaecbcfdec57cc5a.svg";